import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlPoolTableDataset } from 'app/model/dataset/sql-pool-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlDWSink } from './sqldw.copysink';

@Metamodel.model({
    name: adfModelTypeMap.sqlPool.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(SqlPoolTableDataset) }
})
export class SqlPoolSink extends SqlDWSink {
    public static readonly MODEL: IModel;
}
